const componentData = (pageDataAttr, pageContext) => {
  const componentsData = []

  if (pageDataAttr.modelePage.data) {
    for (const componentData of pageDataAttr.modelePage?.data?.attributes
      ?.before) {
      componentsData.push(componentData)
    }
  }

  for (const componentData of pageDataAttr.content) {
    switch (componentData.__typename) {
      case "Strapi_ComponentAUtilsComposantsIterable":
        const iterableContent = pageContext.itemData.attributes.content
        if (iterableContent) {
          for (const iterComponentData of iterableContent) {
            componentsData.push(iterComponentData)
          }
        }
        break

      case "Strapi_ComponentAUtilsComposantsHeaderIterable":
        const iterableHeaderContent = pageContext.itemData.attributes.header
        if (iterableHeaderContent) {
          for (const iterComponentData of iterableHeaderContent) {
            componentsData.push(iterComponentData)
          }
        }
        break
      default:
        componentsData.push(componentData)
        break
    }
  }

  if (pageDataAttr.modelePage.data) {
    for (const componentData of pageDataAttr.modelePage?.data?.attributes
      ?.after) {
      componentsData.push(componentData, pageContext)
    }
  }
  return componentsData
}

module.exports = {
  componentData,
}
